import { AddEventsAndMergeTimestamps, Timestamps } from 'Utils/ChaptersToTimestamps';
import {
  Exercise,
  Lecture,
  NoTimeExercise,
  PianoScene,
  Section,
  StaffExercise,
  Tutorial,
} from 'Utils/TutorialConfigHelper';
import timestamps from './level24.json';

const zero = '0:0';

const Level24 = Tutorial(24, zero, [
  Section([
    Lecture('C in the Bass Clef', zero),
    Lecture('C on the Keyboard', zero),
    Exercise(
      'Find C',
      zero,
      PianoScene({
        objectives: [{ target: 'C3', text: 'Play C on your keyboard' }],
      }),
      [],
    ),
  ]),
  Section([
    Lecture('Shifting to C Position', zero),
    Exercise(
      'C Position',
      zero,
      NoTimeExercise({
        centre_align_horizontal: true,
        first_note_offset: 50,
        objectives: [{}, {}],
      }),
      [],
    ),
    Exercise('Playing in Time', zero, StaffExercise({ objectives: [{}, {}] }), []),
  ]),
  Section([
    Lecture('Using Both Hands', zero),
    Exercise('Hands Together', zero, StaffExercise({ objectives: [{}, {}] }), []),
  ]),
  Section([
    Lecture('Octave in the Left Hand', zero),
    Exercise(
      'Playing C to C',
      zero,
      NoTimeExercise({
        centre_align_horizontal: true,
        first_note_offset: 50,
        objectives: [{}, {}],
      }),
      [],
    ),
    Lecture('Octave Stretch', zero),
    Exercise('Playing in Time', zero, StaffExercise({ objectives: [{}, {}] }), []),
  ]),
  Section([
    Lecture('Using Both Hands', zero),
    Exercise('Alternating Hands', zero, StaffExercise({ objectives: [{}] }), []),
    Exercise('Hands Together', zero, StaffExercise({ objectives: [{}] }), []),
  ]),
]);

export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level24);
